import type { DraftForm } from "@src/load-agent/domain/shipmentDraft";
import type { NormalizedFtlShipmentDraft, NormalizedShipmentDraft } from "@src/types/api";

export type InferredFormFields = Record<string, boolean>;
export function computeInferredFormFields(
  requiredFields: Record<string, unknown>,
  form: DraftForm,
  providerId: string | null | undefined
): InferredFormFields {
  void requiredFields;
  void form;
  void providerId;
  return {};
}
export function inferFieldsForLtlLoad(
  normalizedDraft: NormalizedShipmentDraft | null | undefined
): InferredFormFields {
  const inf = normalizedDraft?.inferredFormFields;

  if (!inf || typeof inf !== "object") return {};
  return { ...inf };
}
export function inferFieldsForFtlLoad(
  normalizedDraft: NormalizedFtlShipmentDraft | null | undefined
): InferredFormFields {
  const inf = normalizedDraft?.inferredFormFields;

  if (!inf || typeof inf !== "object") return {};
  return { ...inf };
}
